// extracted by mini-css-extract-plugin
export default {"copyIcon":"Response_copyIcon__86dIW","codeSnippet":"Response_codeSnippet__b3hsK","codeSnippetHead":"Response_codeSnippetHead__1gbfP","mainDiv":"Response_mainDiv__7lnz0"};